<template>
  <div class="modal fade" id="surveyModal" tabindex="-1">
    <div class="modal-dialog modal-xl">
      <div class="modal-content" :key="uniqueKey">

        <div class="modal-header bg-light">
          <div class="d-flex align-items-center">
            <div class="symbol symbol-40px me-3">
              <div class="symbol-label bg-primary">
                <i class="bi bi-file-earmark-bar-graph fs-2 text-white"></i>
              </div>
            </div>
            <div>
              <h5 class="modal-title mb-0">
                {{ isEditMode ? 'Editar Pesquisa' : 'Nova Pesquisa' }}
              </h5>
              <span class="text-muted fs-7">Configure uma pesquisa para coletar feedback dos pacientes</span>
            </div>
          </div>
          <button type="button" class="btn-close" @click="closeModal"></button>
        </div>

        <div class="modal-body">
          <form @submit.prevent="submit">
            <div class="row g-4">
              <!-- Informações Básicas -->
              <div class="col-12">
                <div class="card border-0 bg-light bg-opacity-50">
                  <div class="card-body p-4">
                    <div class="row g-4">
                      <div class="col-md-6">
                        <label class="form-label fw-semibold required">
                          Título da Pesquisa
                        </label>
                        <input type="text" class="form-control form-control-solid"
                               required placeholder="Ex. Pesquisa de satisfação pós-atendimento" v-model="form.survey_title"/>
                      </div>

                      <div class="col-md-6">
                        <label class="form-label fw-semibold required">
                          Tipo de Pesquisa
                        </label>
                        <select v-model="form.survey_type" class="form-select form-select-solid" required>
                          <option :value="type" :key="type" v-for="(typeDsc, type) in surveyTypes">
                            {{ typeDsc }}
                          </option>
                        </select>
                      </div>

                      <div class="col-md-6">
                        <label class="form-label fw-semibold">
                          Descrição
                        </label>
                        <input type="text" class="form-control form-control-solid"
                               placeholder="Descrição opcional da pesquisa" v-model="form.survey_description"/>
                      </div>

                      <div class="col-md-6">
                        <label class="form-label fw-semibold">
                          Orientações
                        </label>
                        <input type="text" class="form-control form-control-solid"
                               placeholder="Instruções para o paciente responder" v-model="form.survey_guidelines"/>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Filtros de Aplicação -->
              <div class="col-12">
                <div class="card border-0">
                  <div class="card-header bg-primary bg-opacity-10 border-bottom-0">
                    <h6 class="card-title text-white mb-0 fw-bold">
                      Aplicação da Pesquisa
                    </h6>
                  </div>
                  <div class="card-body">
                    <div class="row g-4 align-items-end">
                      <div class="col-md-6">
                        <label class="form-label fw-semibold">
                          Especialidade
                        </label>
                        <DropdownUbbi :options="specialties"
                                      :filter="true"
                                      appendTo="self" showClear
                                      v-model="form.id_spec"
                                      optionLabel="spec_name"
                                      optionValue="id_spec"
                                      empty-message="Nenhuma opção"
                                      empty-filter-message="Nenhuma opção encontrada"
                                      id="id_spec"
                                      class="form-control form-control-solid"
                                      placeholder="Todas as especialidades"
                        />
                      </div>

                      <div class="col-md-3">
                        <label class="form-label fw-semibold">
                          Status
                        </label>
                        <div class="form-check form-switch d-flex align-items-center mt-3">
                          <input class="form-check-input" type="checkbox" role="switch" id="survey_active"
                                 v-model="form.survey_active">
                          <label class="form-check-label ms-2 fw-normal" for="survey_active">
                            {{ form.survey_active ? 'Ativa' : 'Inativa' }}
                          </label>
                        </div>
                      </div>

                      <div class="col-md-3">
                        <button type="submit" class="btn btn-primary w-100">
                          <i class="bi bi-check-circle me-1"></i>
                          {{ isEditMode ? 'Atualizar Pesquisa' : 'Criar Pesquisa' }}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>

        <div class="modal-footer">
          <button type="button" class="btn btn-light" @click="closeModal">
            <i class="bi bi-x-circle me-1"></i>
            Cancelar
          </button>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import http from "@/helpers/http";
import Modal from "@/helpers/modal";
import Alert from "@/helpers/alert";
import DropdownUbbi from "@/components/DropdownUbbi.vue";

export default {
  name: "SurveyModal",
  components: {DropdownUbbi},
  props: ['survey'],
  data() {
    return {
      surveyLocal: null,
      surveyTypes: [],
      specialties: [],
      form: {
        survey_title: null,
        survey_description: null,
        survey_type: null,
        survey_active: null,
        survey_guidelines: null,
        id_spec: null,
      },
      selectedSurvey: null,
      surveyId: null,
      uniqueKey: this.date().unix().toString(),
    };
  },
  watch: {
    survey: {
      immediate: true,
      handler(newValue) {
        this.surveyLocal = newValue;
        this.populateModal();
        this.uniqueKey = this.date().unix().toString();
      }
    }
  },
  computed: {
    place() {
      return this.$store.state.auth.place;
    },
    isEditMode() {
      return this.survey !== null;
    }
  },
  mounted() {
    this.uniqueKey = this.date().unix().toString();
    this.loadSurveyTypes();
    this.loadSpecialties();
  },
  methods: {
    date: moment,
    loadSurveyTypes() {
      return http.get(`/places/${this.place.id_place}/surveys/types`).then((response) => {
        this.surveyTypes = response.data;

        return response;
      });
    },
    loadSpecialties() {
      http.get(`/places/${this.place.id_place}/specialties`).then((response) => {
        this.specialties = response.data;
      });
    },
    populateModal() {
      this.surveyId = this.surveyLocal?.id_survey;
      if (!this.surveyId) {
        this.resetModal();
        return;
      }

      this.form = {
        survey_title: this.surveyLocal.survey_title,
        survey_description: this.surveyLocal.survey_description,
        survey_type: this.surveyLocal.survey_type,
        survey_active: this.surveyLocal.survey_active,
        survey_guidelines: this.surveyLocal.survey_guidelines,
        id_spec: this.surveyLocal.id_spec,
      };
    },
    async submit() {
      if (this.isEditMode) {
        await this.updateSurvey();
      } else {
        await this.createSurvey();
      }

      Alert.success('Pesquisa salva com sucesso.');
      this.$emit('surveySaved');
      this.closeModal();
    },
    async createSurvey() {
      await http.post(`/places/${this.place.id_place}/surveys`, this.form);
    },
    async updateSurvey() {
      await http.put(`/places/${this.place.id_place}/surveys/${this.surveyId}`, this.form);
    },
    closeModal() {
      Modal.toggle('#surveyModal');
      this.$emit('onClose');
    },
    resetModal() {
      this.form = {
        survey_title: null,
        survey_description: null,
        survey_type: null,
        survey_active: null,
        survey_guidelines: null,
        id_spec: null,
      };

      this.surveyId = null;
      this.selectedSurvey = null;
    },
  }
}
</script>

<style scoped>
.separator {
  height: 1px;
  background-color: var(--bs-border-color);
  margin: 1rem 0;
}

.card {
  box-shadow: 0 0.5rem 1.5rem 0.5rem rgba(0, 0, 0, 0.075);
  border-radius: 0.75rem;
}

.card-header {
  border-radius: 0.75rem 0.75rem 0 0 !important;
}

.form-check-input:checked {
  background-color: var(--bs-primary);
  border-color: var(--bs-primary);
}

.fs-7 {
  font-size: 0.875rem;
}

/* Responsividade */
@media (max-width: 768px) {
  .modal-xl {
    margin: 0.5rem;
    max-width: calc(100vw - 1rem);
  }

  .row.g-4 > .col-md-6,
  .row.g-4 > .col-md-3 {
    margin-bottom: 1rem;
  }

  .btn.w-100 {
    margin-top: 1rem;
  }
}

@media (max-width: 576px) {
  .col-md-6,
  .col-md-3 {
    margin-bottom: 1rem;
  }

  .d-flex.align-items-end {
    flex-direction: column;
    align-items: stretch !important;
  }

  .btn.w-100 {
    width: 100% !important;
    margin-top: 0.5rem;
  }
}
</style>